import React from 'react';
import { Spinner, MessageEmpty } from '@dotone/react-ui-core';
import MarketplaceItem from './MarketplaceItem';
import MarketplacePagination from './MarketplacePagination';

const MarketplaceList = ({ listProps, data, loading = true, pagination, onListChange }) => {
  const { offerId } = listProps.filters;

  const handlePaginationChange = (values) => {
    onListChange((prev) => ({ ...prev, ...values }));
  };

  return (
    <div>
      {loading ? (
        <Spinner />
      ) : (
        <>
          {data.length ? (
            data.map((item) => <MarketplaceItem key={item.id} item={item} offerId={offerId} />)
          ) : (
            <MessageEmpty className="text-center" />
          )}
          {!!data.length && (
            <MarketplacePagination pagination={pagination} onChange={handlePaginationChange} />
          )}
        </>
      )}
    </div>
  );
};

export default MarketplaceList;
